export const claimListAction = (payload) => {
  return {
    type: "REQ_CLAIM_LIST",
    payload,
  };
};

export const claimListResetAction = (payload) => {
  return {
    type: "RESET_CLAIM",
    payload,
  };
};

export const claimListUpdateAction = (payload) => {
  return {
    type: "UPDATE_CLAIM_LIST",
    payload: { data: payload },
  };
};
